/**
 * Module 00 — Global Shell · Departments service (FE-00-04)
 *
 * Department scope CRUD against identity `/departments`. The shell's scope
 * switcher is normally populated from the session bootstrap's
 * `availableDepartments`; this service backs department management screens and
 * on-demand refreshes.
 */

import { identityClient } from '@/lib/api/identity';

export interface Department {
  id: string;
  name: string;
  orgId: string;
  parentId: string | null;
  createdAt?: string;
}

export interface CreateDepartmentInput {
  orgId: string;
  name: string;
  description?: string;
  parentId?: string | null;
}

export const departmentsService = {
  async list(orgId: string): Promise<Department[]> {
    const res = await identityClient.get<{ departments: Department[] }>('/departments', {
      params: { orgId },
    });
    return res.data.departments;
  },
  async get(id: string): Promise<Department> {
    const res = await identityClient.get<Department>(`/departments/${id}`);
    return res.data;
  },
  async create(input: CreateDepartmentInput): Promise<Department> {
    const res = await identityClient.post<{ data: Department }>('/departments', input);
    return res.data.data;
  },
  async update(id: string, input: Partial<CreateDepartmentInput>): Promise<Department> {
    const res = await identityClient.put<{ data: Department }>(`/departments/${id}`, input);
    return res.data.data;
  },
  async remove(id: string): Promise<void> {
    await identityClient.delete(`/departments/${id}`);
  },
};
